import * as e from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/Repeat.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...t, weights: m }));
o.displayName = "RepeatIcon";
const s = o;
export {
  s as Repeat,
  o as RepeatIcon
};
